  function syncAll() {
    var nodes = document.querySelectorAll('.muster-badge');
    for (var i = 0; i < nodes.length; i++) syncBadge(nodes[i]);
    renderTray();
    if (modalOpen) renderModal();
  }

  function onBadgeClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var b = e.currentTarget;
    var id = b.getAttribute('data-muster-id');
    trayClosed = false; // bei Interaktion Tray wieder einblenden
    if (has(id)) {
      removeId(id);
    } else {
      var item = sampleFor(id, b.getAttribute('data-muster-img'));
      if (!add(item)) {
        toast('Maximal ' + MAX + ' Muster – entferne zuerst eines.');
        return;
      }
      toast('Muster hinzugefügt (' + count() + ' / ' + MAX + ')');
    }
    syncAll();
  }

  // ---- Injection: Collection cards ----
  function injectCards(root) {
    var cards = (root || document).querySelectorAll('product-card[data-product-id]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.muster-badge')) continue;
      var id = card.getAttribute('data-product-id');
      if (!id) continue;
      if (EXCLUDE[id]) continue; // Testpaket Stelzlager/Balkenlager ausgeschlossen
      // Nur Produkte mit Tag group:Muster (stehen in SAMPLES)
      if (!Object.prototype.hasOwnProperty.call(SAMPLES, id)) continue;
      var header = card.querySelector('.product-card__image-wrapper, .card__header, .product-card__image, .media-wrapper') || card;
      if (window.getComputedStyle(header).position === 'static') header.style.position = 'relative';
      var img = card.querySelector('img');
      var domImg = img ? (img.getAttribute('src') || '') : '';
      var badge = makeBadge(id, domImg);
      badge.classList.add('muster-badge--card');
      // 13.10.2026: Knopf steht jetzt im Badge-Container oben links (unter "Gratis Musterversand" usw.),
      // Desktop und Handy gleich - vorher oben rechts, wo er auf schmalen Karten mit dem Badge kollidierte.
      // Fehlt der Container (Produkt ohne Badge), wird er angelegt, damit der Knopf immer an derselben Stelle sitzt.
      var box = card.querySelector('.product-card__badge');
      if (!box) {
        box = document.createElement('div');
        box.className = 'product-card__badge';
        header.appendChild(box);
      }
      badge.classList.add('muster-badge--stack');
      box.appendChild(badge);
    }
  }

  // ---- Nachladen: Karten, die nicht im server-seitigen SAMPLES stehen ----
  // (z. B. via "Mehr anzeigen" / Infinite-Scroll nachgeladene Produkte, oder Collections > 50).
  // Holt Produktdaten on-demand und ergänzt SAMPLES, damit der Badge auch dort erscheint.
  var enrichTried = {};
  function enrichCards(root) {
    var cards = (root || document).querySelectorAll('product-card[data-product-id]');
    Array.prototype.forEach.call(cards, function (card) {
      var id = card.getAttribute('data-product-id');
      if (!id) return;
      if (EXCLUDE[id]) return; // Testpaket Stelzlager/Balkenlager ausgeschlossen
      if (Object.prototype.hasOwnProperty.call(SAMPLES, id)) return; // schon bekannt
      if (card.querySelector('.muster-badge')) return;
      if (enrichTried[id]) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = m[1];
      // Nur Muster-Produkte antasten: Kartentitel ODER Handle enthält "Muster"
      var probe = ((card.textContent || '') + ' ' + handle).toLowerCase();
      if (probe.indexOf('muster') === -1) return;
      enrichTried[id] = 1;
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var isMuster = (p.tags || []).some(function (t) { return String(t).toLowerCase() === 'group:muster'; });
          if (!isMuster) return;
          if (p.type === 'Testpaket-Stelzlager') return; // Testpakete ausgeschlossen
          var variant = null, img = null;
          if (p.price === 0) { // kostenloses Muster -> eigene Variante bestellbar
            var av = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
            variant = av ? av.id : null;
            img = p.featured_image || (p.images && p.images[0]) || null;
          }
          SAMPLES[String(id)] = { v: variant, img: img, name: p.title || null };
          injectCards(document);
          syncAll();
        })
        .catch(function () {});
    });
  }

  // ---- Injection: PDP ----
  function findPdpMediaContainer() {
    var sels = [
      '.product__media-wrapper', '.product-media-container', 'media-gallery',
      '.product__media-list', '.product__media-gallery', '.product-single__media',
      '.product__column-image', '[data-product-media-wrapper]'
    ];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el && !el.closest('product-card')) return el;
    }
    return null;
  }

  function injectPdp() {
    if (!/\/products\//.test(window.location.pathname)) return;
    if (document.querySelector('.muster-badge--pdp')) return;
    if (!PDP || PDP.allowed !== true) return; // nur Produkte mit Tag group:Muster
    if (EXCLUDE[String(PDP.id)]) return; // Testpakete ausgeschlossen
    var container = findPdpMediaContainer();
    if (!container) return;
    var id = PDP && PDP.id ? String(PDP.id) : null;
    if (!id) {
      try {
        if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) id = String(ShopifyAnalytics.meta.product.id);
      } catch (e) {}
    }
    if (!id) return;
    var cs = window.getComputedStyle(container);
    if (cs.position === 'static') container.style.position = 'relative';
    var img = container.querySelector('img');
    var domImg = img ? (img.getAttribute('src') || '') : '';
    var badge = makeBadge(id, domImg);
    badge.classList.add('muster-badge--pdp');
    container.appendChild(badge);
  }

  // ---- PDP: "In den Warenkorb legen" wählt das Muster aus (statt direkt in den Warenkorb) ----
  function isPdpMusterContext() {
    return /\/products\//.test(window.location.pathname) && PDP && PDP.allowed === true && !EXCLUDE[String(PDP.id)];
  }
  function pdpMusterSelect() {
    if (!isPdpMusterContext()) return;
    var id = PDP.id ? String(PDP.id) : null;
    if (!id) return;
    trayClosed = false; // Auswahl-Fenster wieder einblenden
    if (has(id)) {
      removeId(id);
      toast('Muster entfernt (' + count() + ' / ' + MAX + ')');
    } else {
      var item = sampleFor(id, (PDP && PDP.img) || null);
      if (!add(item)) { toast('Maximal ' + MAX + ' Muster – entferne zuerst eines.'); return; }
      toast('Muster ausgewählt (' + count() + ' / ' + MAX + ')');
    }
    syncAll();
    relabelPdpCta();
  }
  // Beschriftet den Produktformular-Button auf Muster-PDPs um (kein Warenkorb, nur Musterkorb)
  function relabelPdpCta() {
    if (!isPdpMusterContext()) return;
    var onSel = has(String(PDP.id));
    var label = onSel ? LABEL_SEL : LABEL_ADD; // "Muster gewählt" / "Muster auswählen"
    var btns = document.querySelectorAll('form[action*="/cart/add"] [name="add"], .product-form__submit[name="add"]');
    Array.prototype.forEach.call(btns, function (btn) {
      var t = btn.querySelector('.btn__text') || btn;
      if ((t.textContent || '').trim() !== label) t.textContent = label; // nur bei Änderung -> keine Render-Schleife
    });
  }
  // ---- "Kostenloses Muster bestellen"-Block (.mh-sample) auf Haupt-Produktseiten ----
  // Legt das Muster NICHT in den Warenkorb, sondern in den Musterkorb (gleiche Logik wie Collection/PDP).
  function mhSampleForm(el) {
    var f = el && el.closest ? el.closest('form[action*="/cart/add"]') : null;
    if (f && f.querySelector('[name="properties[_sample]"]')) return f;
    return null;
  }
  function mhSampleSelect(form) {
    if (!form) return;
    var pidEl = form.querySelector('[name="product-id"]');
    var vidEl = form.querySelector('[name="id"]');
    var pid = pidEl ? String(pidEl.value) : null;
    var vid = vidEl ? String(vidEl.value) : null;
    var id = pid || vid;
    if (!id) return;
    trayClosed = false;
    if (has(id)) {
      removeId(id);
      toast('Muster entfernt (' + count() + ' / ' + MAX + ')');
    } else {
      var img = (PDP && PDP.v && String(PDP.v) === vid && PDP.img) ? PDP.img : null;
      var item = { id: id, v: vid ? Number(vid) : null, img: img, name: null };
      if (!add(item)) { toast('Maximal ' + MAX + ' Muster – entferne zuerst eines.'); return; }
      toast('Muster ausgewählt (' + count() + ' / ' + MAX + ')');
    }
    syncAll();
    relabelMhSample();
  }
  function relabelMhSample() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (f) {
      if (!f.querySelector('[name="properties[_sample]"]')) return;
      var pidEl = f.querySelector('[name="product-id"]');
      var vidEl = f.querySelector('[name="id"]');
      var id = (pidEl && pidEl.value) || (vidEl && vidEl.value);
      if (!id) return;
      var on = has(String(id));
      var btn = f.querySelector('.mh-sample__btn') || f.querySelector('[name="add"]');
      if (!btn) return;
      var span = btn.querySelector('.btn__text') || btn.querySelector('span') || btn;
      var label = on ? LABEL_SEL : LABEL_ADD;
      if ((span.textContent || '').trim() !== label) span.textContent = label;
    });
  }
  var pdpHooked = false;
  function hookPdpAddButtons() {
    if (pdpHooked) return;
    pdpHooked = true;
    // Auf Dokument-Ebene in der Capture-Phase abfangen -> vor Theme-Handlern.
    document.addEventListener('click', function (e) {
      var t = e.target;
      // 1) "Kostenloses Muster bestellen"-Block (.mh-sample) -> Musterkorb (auf jeder Seite)
      var mhTrigger = t && t.closest ? t.closest('.mh-sample__btn, .mh-sample__inner [name="add"]') : null;
      var mhF = mhTrigger ? mhSampleForm(mhTrigger) : (t && t.closest ? mhSampleForm(t.closest('[name="add"]')) : null);
      if (mhF) { e.preventDefault(); e.stopImmediatePropagation(); mhSampleSelect(mhF); return; }
      // 2) Standard-Produktformular auf Muster-PDP
      if (!isPdpMusterContext()) return;
      var btn = t && t.closest ? t.closest('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] .product-form__submit, [name="add"].product-form__submit') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      pdpMusterSelect();
    }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target;
      // 1) Sample-Formular (.mh-sample / properties[_sample]) -> Musterkorb
      if (f && f.querySelector && f.querySelector('[name="properties[_sample]"]')) {
        e.preventDefault(); e.stopImmediatePropagation(); mhSampleSelect(f); return;
      }
      // 2) Standard-Produktformular auf Muster-PDP
      if (!isPdpMusterContext()) return;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      pdpMusterSelect();
    }, true);
  }

  // ---- Wieder-öffnen-Button (z. B. "3 / 5 Muster") neben dem Warenkorb-Icon ----
  var reopenEl;
